/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RvcSicherungHochladenRequest
 */
export interface RvcSicherungHochladenRequest {
    /**
     * Die in base64 enkodierte Sicherungsdatei.
     * @type {string}
     * @memberof RvcSicherungHochladenRequest
     */
    sicherung: string;
    /**
     * 
     * @type {string}
     * @memberof RvcSicherungHochladenRequest
     */
    dateiName: string;
}

/**
 * Check if a given object implements the RvcSicherungHochladenRequest interface.
 */
export function instanceOfRvcSicherungHochladenRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sicherung" in value;
    isInstance = isInstance && "dateiName" in value;

    return isInstance;
}

export function RvcSicherungHochladenRequestFromJSON(json: any): RvcSicherungHochladenRequest {
    return RvcSicherungHochladenRequestFromJSONTyped(json, false);
}

export function RvcSicherungHochladenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RvcSicherungHochladenRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sicherung': json['sicherung'],
        'dateiName': json['dateiName'],
    };
}

export function RvcSicherungHochladenRequestToJSON(value?: RvcSicherungHochladenRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sicherung': value.sicherung,
        'dateiName': value.dateiName,
    };
}

